import React from 'react';

interface IProps {
  style?: any;
}

const DeleteIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={props.style} width="20" height="25" fill="none" viewBox="0 0 20 25">
      <path fill={props.style?.fillColor ? props.style.fillColor : "#204078"} fillOpacity={props.style?.fillOpacity ? props.style.fillOpacity : ""} d="M20 3.125v1.25c0 .345-.28.625-.625.625H.625C.28 5 0 4.72 0 4.375v-1.25C0 2.78.28 2.5.625 2.5H6.25V1.25C6.25.56 6.81 0 7.5 0h5c.69 0 1.25.56 1.25 1.25V2.5h5.625c.345 0 .625.28.625.625zM2.337 22.675c.093 1.312 1.185 2.328 2.5 2.325h10.35c1.316.003 2.408-1.013 2.5-2.325L18.75 7.5H1.25l1.087 15.175z"/>
    </svg>
  )
}

export default DeleteIcon;